var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultVideoBlockNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 179296",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6641",
    style: {
      fill: "#fff",
      stroke: "#e1e1e1",
      strokeDasharray: "2 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v39H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146607",
    transform: "translate(4 4)",
    style: {
      fill: "#e1e1e1"
    },
    d: "M0 0h166v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29643",
    d: "M7.4 18h10.2a1.2 1.2 0 0 0 1.2-1.2V7.2A1.2 1.2 0 0 0 17.6 6H7.4a1.2 1.2 0 0 0-1.2 1.2v2.436L2.948 7.314A.6.6 0 0 0 2 7.8v8.4a.6.6 0 0 0 .948.486L6.2 14.364V16.8A1.2 1.2 0 0 0 7.4 18zM17.6 7.2v9.6H7.4v-3.6a.6.6 0 0 0-.948-.486L3.2 15.036V8.964l3.252 2.322A.6.6 0 0 0 7.4 10.8V7.2z",
    transform: "translate(76.601 8)",
    style: {
      fill: "#231f20"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultVideoBlockNewIcon);
export default __webpack_public_path__ + "static/media/default_video_block_new_icon.58f3184c05e2e15580a3465256e37fb2.svg";
export { ForwardRef as ReactComponent };